/** Shared formatters for audit log table cells and CSV-adjacent UI. */

const AUDIT_SOURCE_LABELS: Record<string, string> = {
  sso: "SSO",
  directory_sync: "Directory sync",
  manual: "Manual (Owner)",
  cli: "CLI",
  login: "Password login",
  scim_webhook: "SCIM webhook",
  system: "System",
};

export const formatAuditUser = (email: string | null, userId: number | null): string => {
  if (email) {
    return email;
  }
  if (userId !== null) {
    return `#${userId}`;
  }
  return "—";
};

export const formatAuditSource = (source: string): string => {
  const normalized = source.trim().toLowerCase();
  if (AUDIT_SOURCE_LABELS[normalized]) {
    return AUDIT_SOURCE_LABELS[normalized];
  }
  return normalized.replace(/_/g, " ");
};
